import Grid from "@mui/material/Grid2";
import {
    DataGrid,
    GridColDef,
    GridEventListener,
    GridRowSelectionModel,
    useGridApiRef,
} from "@mui/x-data-grid";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import { DynsCard } from "src/stateManagement/redux/slices/location/interfaces";
import { Graphics } from "./components/Graphics";
import { IconButton, Typography } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import UnfoldMoreDoubleIcon from '@mui/icons-material/UnfoldMoreDouble';
import UnfoldLessDoubleIcon from '@mui/icons-material/UnfoldLessDouble';
import { Filter, FilterDrawer, FilterList } from "src/shared/modules/filterDrawer";
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
import { set } from "react-datepicker/dist/date_utils";

const filters: FilterList[] = [
    {
        name: 'Fecha Inicio',
        field: 'fromDate',
        type: 'date',
        action: 'equalAfter',
        buttons: [],
        options: []
    },
    {
        name: 'Fecha Fin',
        field: 'toDate',
        type: 'date',
        action: 'equalBefore',
        buttons: [],
        options: []
    },
    {
        name: 'Analizado',
        field: 'status',
        type: 'groupButton',
        buttons: [
            { id: 0, name: 'Todo', value: "", action: 'dissable' },
            { id: 1, name: 'SI', value: "completed", action: 'equal' },
            { id: 2, name: 'NO', value: "pending", action: 'equal' }
        ],
        options: []
    },
    {
        name: 'Tipo de Actividad',
        field: 'typeOfActivity',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["Estudio Completo", "Revisión", "Carta Dinagrafica", "Nivel Dinámico", "Carta Leuter", "Nivel Estático"]
    },
    {
        name: 'Condición',
        field: 'condition',
        type: 'Autocomplete',
        action: 'include',
        buttons: [],
        options: ["Golpe de Fluido", "Inteferencia por Gas", "Pendiente por Determinar", "Buenas Condiciones", "Golpe de Bomba", "Fuga en Valvula Viajera", "Fuga en Valvula Fija", "Cierre Tardio de Valvula Fija", "Cierra Tardio de Valvula Viajera", "Flumping"]
    },
]

export const DinagraphiCards = () => {
    // const apiRef = useGridApiRef();
    const { dynsCards } = useSelector((state) => state.location);
    const [data, setData] = useState<DynsCard[]>([]);
    const [dynCardList, setDynCardList] = useState<DynsCard[]>();
    const [showFilters, setshowFilters] = useState(false)
    const [expandTable, setExpandTable] = useState(false)
    const [filteredData, setFilteredData] = useState<Filter[]>([]);
    const [expandCard, setExpandCard] = useState(false)

    const columns: GridColDef[] = [
        { field: "executedDate", headerName: "Fecha", flex: 0.6 },
        { field: "typeOfActivity", headerName: "Actividad", flex: 1 },
        { field: "condition", headerName: "Condición", flex: 1 },
        { field: "fillage", headerName: "% Llenado", flex: 0.5 },
        { field: "presureTestExecuted", headerName: "PP", flex: 0.1, type: 'boolean'},
        { field: "valveTestExecuted", headerName: "PV", flex: 0.1, type: 'boolean' },
        {
            field: 'status', headerName: "Analizado", type: 'boolean', flex: 0.1, renderCell: (params) => {
                if (params.value === 'completed') {
                    return (
                        <IconButton size="small" color="success">
                            <DoneIcon />
                        </IconButton>
                    )
                } else if (params.value === 'analyzing') {
                    return (
                        <IconButton size="small" color="warning">
                            <WarningIcon />
                        </IconButton>
                    )
                } else {
                    return ""
                }
            }
        },
    ]
    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {

        let allDynsCards = dynsCards

        for (const element of filteredData) {

            if (element.action === 'equalAfter') {
                allDynsCards = allDynsCards.filter(
                    (dynCard) => {

                        const cardDate = moment(dynCard.executedDate)

                        return cardDate.isSameOrAfter(element.value, 'day')
                    }
                );
            }

            if (element.action === 'equalBefore') {
                allDynsCards = allDynsCards.filter(
                    (dynCard) => {

                        const cardDate = moment(dynCard.executedDate)

                        return cardDate.isSameOrBefore(element.value, 'day')
                    }
                );
            }

            if (element.action === 'equal') {
                allDynsCards = allDynsCards.filter(
                    (dynCard: any) => dynCard[element.field || element?.name] === element.value
                );
            }

            if (element.action === 'include' && element.value.length > 0) {
                allDynsCards = allDynsCards.filter(
                    (dynCard: any) => element.value.includes(dynCard[element.field || element?.name])
                );
            }
        }

        allDynsCards = allDynsCards?.map((dynCard) => {

            const valTest = dynCard?.activityVariables?.find((variable) => variable.id === "8a8c2c05-d3b1-410c-bb3e-a8fd717f0e86");
            const pressureText = dynCard?.activityVariables?.find((variable) => variable.id === "e377cb89-3cf0-422f-a05b-a17f73187544");
            
            return {
                ...dynCard,
                completed: dynCard.status === 'completed',
                presureTestExecuted: pressureText ? pressureText.value==='true' : false,
                valveTestExecuted: valTest ? valTest.value === 'true' : false,
            };
        })

        setData(allDynsCards);

        // allow to refressh the selected
        for (const element of dynCardList || []) {
            const dataDyns: DynsCard[] = []

            const card = allDynsCards.find((dynCard) => dynCard.fieldActivityId === element.fieldActivityId);
            if (card) {
                dataDyns.push(card)
            }

            if (dataDyns.length > 0) {
                setDynCardList([])
                setTimeout(() => {
                    setDynCardList(dataDyns)
                }, 100);
            }
        }

    }, [dynsCards, filteredData]);

    const handleSelectCard = (params: GridRowSelectionModel) => {
        const dataDyns: DynsCard[] = []

        for (const id of params) {
            const card = data.find((dynCard) => dynCard.fieldActivityId === id);
            if (card) {
                dataDyns.push(card)
            }
        }

        setDynCardList(dataDyns)
    }

    const handleResetSearch = () => {
        setFilteredData([]);
        setData(dynsCards);
    };

    const handleSelectOptionFilter = (filter: Filter) => {
        const extraFilter = filteredData.filter(f => f.name !== filter.name);
        setFilteredData([...extraFilter, filter]);
    };

    const handleExpand = (expand: boolean, action: 'table' | 'card') => {
        if (action === 'table') {
            setExpandTable(expand)
            setExpandCard(false)
        } else {
            setExpandCard(expand)
            setExpandTable(false)
        }
    }


    return (
        <Grid container spacing={1} sx={{ height: "100%" }}>
            {/* Left Table */}
            <Grid size={expandTable ? 9 : expandCard ? 3 : 6}>
                <Grid container spacing={1} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="body1" color="primary" sx={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'center' }}>
                        Lista de Estudios
                    </Typography>
                    <Grid>
                        <IconButton
                            size="small"
                            color="primary"
                            sx={{ mr: 2 }}
                            onClick={() => setshowFilters(!showFilters)}
                        >
                            <TuneIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            sx={{ mr: 2, transform: 'rotate(90deg)' }}
                            onClick={() => handleExpand(!expandTable, "table")}
                        >
                            {expandTable ? <UnfoldLessDoubleIcon /> : <UnfoldMoreDoubleIcon />}
                        </IconButton>
                    </Grid>

                    <FilterDrawer
                        showFilters={showFilters}
                        filters={filters}
                        filteredData={filteredData}
                        setshowFilters={setshowFilters}
                        handleSelectOptionFilter={handleSelectOptionFilter}
                        resetFilters={handleResetSearch}
                    />
                </Grid>
                {/* Table */}
                <Grid>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={true}
                        // apiRef={apiRef}
                        sx={{
                            border: 0,
                            mt: 2,
                            fontSize: "12px",
                            fontWeight: "bold",
                            "& .MuiDataGrid-row:hover": {
                                cursor: "pointer",
                                backgroundColor: "#f5f5f5",
                            },
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#316EBC",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                        }}
                        getRowId={(row) => row.fieldActivityId}
                        onRowSelectionModelChange={(params) => handleSelectCard(params)}
                    />
                </Grid>

            </Grid>
            {/* Card Garph right */}
            {dynCardList && dynCardList.length > 0 && (
                <Grid size={expandTable ? 3 : expandCard ? 9 : 6}>

                    {dynCardList && <Graphics dynCardList={dynCardList} expandCard={expandCard} setExpandCard={handleExpand} />}

                </Grid>
            )}

        </Grid>
    );
};
